<template>
  <Page bg_color="bg-white">
    <v-img
      cover
      :src="login_bg_url"
      gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
    >
      <!-- https://www.vuescript.com/vue-js-component-particles-backgrounds/ -->
      <vue-particles
        color="#dedede"
        :particleOpacity="0.7"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
        class="particles-bg-js"
      >
      </vue-particles>
      <CenterPageColumn :outlined="false" :has_nav_bar="true">
        <CenterNavbar
          :crumps="[]"
          title=""
          :width_class="page_info.center_width_class"
          bg_color=""
        ></CenterNavbar>
        <ContactPageBanner
          bg_url=""
          :has_nav_bar="true"
          id="login_form_top"
          logo_class="logo-bg2"
        ></ContactPageBanner>

        <CardedForm
          style="max-width: 600px; margin: auto !important"
          ref="carded_signup_form_ref"
          id="signup_form"
          title="Join BUsyug"
          :is_loading="is_loading"
          @on-submit-form="on_signup"
          :errors="errors"
          :message="message"
          @on-auto-fill="on_auto_fill"
          @on-close-message="on_hide_message"
        >
          <v-row>
            <v-col>
              <TextField
                v-model="form.first_name"
                :validation_rules="first_name_rules"
                label="First Name"
                icon="mdi-user"
                :disabled="is_loading"
              ></TextField>
            </v-col>
            <v-col>
              <TextField
                v-model="form.last_name"
                :validation_rules="last_name_rules"
                label="Last Name"
                icon="mdi-user"
                :disabled="is_loading"
              ></TextField>
            </v-col>
          </v-row>

          <TextField
            v-model="form.email"
            :validation_rules="email_rules"
            label="E-mail Address/ Phone Number"
            icon="mdi-email-variant"
            :disabled="is_loading"
          ></TextField>

          <v-row no-gutters >
            <v-col no-gutters class="pr-5">
              <TextField
                v-model="form.password"
                :validation_rules="password_rules"
                label="Password"
                type="password"
                icon="mdi-key-variant"
                :disabled="is_loading"
              ></TextField>
            </v-col>
            <v-col no-gutters>
              <TextField
                v-model="comfirm_password"
                :validation_rules="password_rules"
                label="Confirm Password "
                type="password"
                icon="mdi-key-variant"
                :disabled="is_loading"
              ></TextField>
            </v-col>
          </v-row>

          <template v-slot:lower>
            <div class="text-muted mt-5">-- OR --</div>
            <v-divider></v-divider>
            <v-row class="mb-5">
              <v-col cols="12 mt-0 mb-1 pb-0 pt-2 text-left">
                <v-btn
                  class="ma-0 mb-2"
                  to="/login"
                  dense
                  text
                  color="success"
                  :disabled="is_loading"
                >
                  Take me to Login
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </CardedForm>
      </CenterPageColumn>
    </v-img>
    <v-row class="ma-0 pa-0 bg-footer" no-gutters>
      <v-col cols="2" class="ma-0 pa-0 wrapper-bg" no-gutters></v-col>
      <v-col class="ma-0 pl-0 bg-footer" no-gutters>
        <Footer
          :is_loading="is_loading"
          @on-hide-loader="$emit('on-hide-loader')"
          @on-show-loader="$emit('on-show-loader')"
        ></Footer>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0 wrapper-bg" no-gutters></v-col>
    </v-row>
  </Page>
</template>

<script>
import Page from "./../../components/Page";
import Footer from "./../../components/CenterFooter";
import CenterPageColumn from "./../../components/CenterPageColumn";
import CenterNavbar from "./../../components/CenterNavbar";
import ContactPageBanner from "./../../components/ContactPageBanner";
import TextField from "./../../components/TextField";
import CardedForm from "./../../components/CardedForm";
import page_info from "./../../lib/page_info";
import Utils from "./../../lib/Utils";
import ServerClient from "./../../lib/ServerClient";
export default {
  name: "Signup",
  components: {
    Page,
    Footer,
    CenterPageColumn,
    CenterNavbar,
    ContactPageBanner,
    TextField,
    CardedForm,
  },
  data() {
    return {
      page: "signup",
      login_bg_url:
        "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1602788555/botswana%20services/website%20assets/login_bg_qmbfxp.png",
      errors: [],
      message: "",
      page_info: page_info,
      form: {
        first_name: "",
        last_name: "",
        email: "",
        country: "botswana",
        password: "",
      },
      first_name_rules: [
        Utils.validate.is_required("First name is required"),
        Utils.validate.min_max_length(
          3,
          20,
          "First name should be between 3 and 20 characters "
        ),
      ],
      last_name_rules: [
        Utils.validate.is_required("Last name is required"),
        Utils.validate.min_max_length(
          3,
          20,
          "Last name should be between 3 and 20 characters "
        ),
      ],
      email_rules: [
        Utils.validate.is_required("Email address or Phone number is required"),
        Utils.validate.email_format_or_phone(
          "Invalid input, must be a valid email address or a valid phone number"
        ),
      ],
      password_rules: [
        Utils.validate.is_required("Password is required"),
        Utils.validate.min_max_length(
          6,
          10,
          "Password should be between 6 and 10 characters"
        ),
      ],
      email_used: "",
      prevRoute: "",
      comfirm_password: "",
    };
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
      localStorage.setItem("before_singup_route", from.path);
    });
  },
  methods: {
    on_auto_fill() {
      var rnd = Math.ceil(Math.random() * 100);
      this.form.first_name = "kgomotso" + rnd;
      this.form.last_name = "Gabarekwe" + rnd;
      this.form.email = "77393543"; //"dev@solidcareservices.com" ;
      this.form.country = "botswana";
      this.form.password = "qwerty";
      this.comfirm_password = "qwerty";
    },
    on_signup() {
      this.form.password = this.form.password.trim();
      this.comfirm_password = this.comfirm_password.trim();
      if (this.form.password !== this.comfirm_password) {
        this.errors = ["The two passwords are not the same"];
        this.$refs.carded_signup_form_ref.show_error_dialog();
        return false;
      }

      //form is already validated
      this.email_used = this.form.email;
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Signup.signup(
        {
          ...this.form,
        },
        (res) => {
          this.$emit("on-hide-loader");
          // console.log("login ", res);
          this.$refs.carded_signup_form_ref.on_clear_form();
          var msg =
            "<b>Signup was succesfull</b> <br/>  Thank you for joining  BUsyug.";
          if (this.email_used.indexOf("@") > 0) {
            msg =
              msg +
              " <br/><br/> <b class='success--text'>Please check your email " +
              this.email_used +
              " for an activation link</b>";
          } else {
            msg =
              msg +
              " <br/><br/> <b class='success--text'>Please check your phone " +
              this.email_used +
              " for an sms with the activation code</b>";
          }
          this.message = msg;
          this.$refs.carded_signup_form_ref.show_message_dialog();
          
        },
        (errors) => {
          // console.log("errors ", errors);
          this.errors = errors;
          this.$refs.carded_signup_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    on_hide_message() {
      if (this.email_used.indexOf("@") > 0) {
        this.$router.go(-1);
      } else {
        this.$router.push("/activate");
      }
    },
  },
};
</script>